import { getAuthHash } from "@/api/_manager";
import store from '@/store';
import DEFINES from "@/defines";
import i18n from "@/i18n";
import { EventBus } from "@/event-bus";

var hlsInstance = null

const config = (accessToken=null) => {
  return {
    maxBufferLength: 20,
    liveBackBufferLength: 18,
    debug: false
  }
}

/**
 * Initialise hls player with its listeners
 * @param {*} video Video player instance
 * @param {*} url Source url of movie
 * @param {*} accessToken access token for screener
 * @returns
 */
const initialize = (video, url, accessToken) => {
    if (Hls.isSupported()){
        var hls = new Hls(config(accessToken));
        hls.loadSource(url);
        hls.attachMedia(video);
        hlsInstance = hls;

        /**
         * Configure error listners
         */
        hls.on(Hls.Events.ERROR,function(event, data) {
            return errorHandler(event, data)
        })

        /**
         * Configure available qualities/resolutions
         */
        hls.on(Hls.Events.MANIFEST_PARSED, function () {
          handelResolutionSwitcher(hls);
        });

      return hls;
    }

    /**
     * HLS is not supported
     * hls.js is not supported on platforms that do not have Media Source Extensions (MSE) enabled.
     * When the browser has built-in HLS support (check using `canPlayType`), we can provide an HLS manifest (i.e. .m3u8 URL) directly to the video element through the `src` property.
     * This is using the built-in support of the plain video element, without using hls.js.
     * Note: it would be more normal to wait on the 'canplay' event below however on Safari (where you are most likely to find built-in HLS support) the video.src URL must be on the user-driven
     * white-list before a 'canplay' event will be emitted; the last video event that can be reliably listened-for when the URL is not on the white-list is 'loadedmetadata'.
    */
    if(video.canPlayType("application/vnd.apple.mpegurl")) {
      video.src = url;
      video.play();
    }

}

const errorHandler = (event, data) => {
    switch (data.type) {
        case Hls.ErrorTypes.NETWORK_ERROR:
            networkErrorHandler(data, hlsInstance);
            break;
        case Hls.ErrorTypes.MEDIA_ERROR:
            mediaErrorHandler(data, hlsInstance);
            break;
        default:
            store.dispatch("app/showMessage", {
                message: i18n.t("screener.watch.cannot_recover"),
                color: "error",
            });
        break;
    }
}

/**
 *
 * @param {*} data Error instance
 * @param {*} hls Hls instance
 * @returns
 */
const networkErrorHandler = (data, hls) => {
    try {
        // if response is undefined
        if (data.response == undefined) {
        //   hls.startLoad();
          return;
        }

        // if response code is there
        switch (data.response.code) {
          case DEFINES.EVENT_NOT_STARTED:
            store.dispatch("app/showMessage", {
              message: i18n.t("screener.watch.screening_started"),
              color: "error",
            });
            break;

          case DEFINES.SERVER_ERROR:
            store.dispatch("app/showMessage", {
              message: i18n.t("screener.watch.server_error"),
              color: "error",
            });
            hls.destroy();
            break;

          case DEFINES.TOKEN_MISSING:
            store.dispatch("app/showMessage", {
              message: i18n.t("screener.watch.token_missing"),
              color: "error",
            });
            hls.destroy();
            break;

          case DEFINES.TOKEN_MISMATCH:
            store.dispatch("app/showMessage", {
              message: i18n.t("screener.watch.token_not_match"),
              color: "error",
            });
            hls.destroy();
            break;

          case DEFINES.UNENROLLED:
            store.dispatch("app/showMessage", {
              message: i18n.t("screener.watch.not_enrolled"),
              color: "error",
            });
            hls.destroy();
            break;

          case DEFINES.EVENT_FINISHED:
            store.dispatch("app/showMessage", {
              message: i18n.t("screener.watch.screening_ended"),
              color: "error"
            });
            hls.destroy();
            break;
            case DEFINES.EVENT_EXPIRED:
              store.dispatch("app/showMessage", {
                message: i18n.t("screener.watch.event_expired"),
                color: "error"
              });
              hls.destroy();
              break;

          case DEFINES.GEO_BLOCKED:
            store.dispatch("app/showMessage", {
              message: i18n.t("screener.geo_blocked"),
              color: "error",
            });
            hls.destroy();
            break;

          case DEFINES.SESSION_DELETED:
          store.dispatch("app/showMessage", {
            message: i18n.t("screener.watch.session_deleted"),
            color: "error"
          });
          hls.destroy();
          break;

        default :
          // In case of manifest error, we do not have specific error code
          if(data.fatal && data.details == DEFINES.MANIFEST_LOAD_ERROR){
            store.dispatch("app/showMessage", {
              message: i18n.t("screener.watch.manifest_load_error"),
              color: "error"
            });
          }
          break;
         /**
           * ----- Default do nothing as hls will handle itself -----
           * */
        }
      } catch (error) {
        hls.startLoad();
      }
}

const mediaErrorHandler = (data, hls) => {
    if (data.fatal) {
        // console.log("handling media error")
        // hls.startLoad();
    }
}

/**
 * Prepare available resolutions
 * @param {*} hlsObj
 */
function handelResolutionSwitcher(hlsObj){
  /**
   *  1. Get available resolution and set these resolutions
   *  into player.
   */
    let availableQualities = hlsObj.levels.map((level) => {
      return {
        default: level.height==hlsObj.currentLevel,
        html: level.height+' (px)',
        url: level.url[0],
        height: level.height
      }
    })

  EventBus.$emit("hls:availableResolutions",availableQualities);
  /**
   * 2. Bind a listner to switch video resolution
   */
   EventBus.$on("hls:switchVideoResolution", payload => {
    let nextResolutionIndex = availableQualities.findIndex(item => item.height == payload.height)
    hlsObj.currentLevel = nextResolutionIndex;
  });

}

export {
    initialize
}
